import styled from 'styled-components';

import { SWReactIcons } from '@similarweb/icons';
import { colorsPalettes, setFontVariant } from '@similarweb/styles';

import { Skeleton } from '../../../components/Skeleton';

export const StyledEmailsContainer = styled.div`
  margin-top: 24px;
  display: flex;
  flex-direction: column;
  row-gap: 16px;
`;

export const StyledEmailCard = styled.div`
  background-color: ${colorsPalettes.carbon[0]};
  display: flex;
  flex-direction: column;
  row-gap: 16px;
  padding: 16px;
  border-radius: 8px;
  box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.05);
  border: 1px solid #ececec;
  overflow: hidden;
  z-index: 0;
`;

export const StyledEmailCardHeader = styled.div`
  display: inline-flex;
  align-items: center;
  column-gap: 8px;
`;

export const StyledEmailInsight = styled.span`
  ${setFontVariant('sectionTitle', colorsPalettes.carbon[300])};
`;

export const StyledEmailSection = styled.div`
  display: flex;
  flex-wrap: wrap;
  padding: 16px 16px 8px 16px;
  background-color: ${colorsPalettes.bluegrey[100]};
  border-radius: 6px;
`;

export const StyledEmailIcon = styled(SWReactIcons)`
  width: 16px;
  height: 16px;
`;

export const StyledEmailText = styled.p`
  ${setFontVariant('report', colorsPalettes.carbon[400])};
  line-height: 18px;
  white-space: pre-wrap;
  margin: 0;
  width: 100%;
`;

export const StyledChangeCompetitors = styled.button`
  padding: 0;
  border: none;
  background-color: transparent;
  ${setFontVariant('sectionTitle', colorsPalettes.blue[500])};
  text-align: left;
  cursor: pointer;
  width: 100%;

  &:hover {
    text-decoration: underline;
  }

  &:disabled {
    cursor: not-allowed;
    color: ${colorsPalettes.carbon[100]};
    &:hover {
      text-decoration: none;
    }
  }
`;

export const StyledSeparator = styled.div`
  width: 100%;
  height: 0.5px;
  background-color: ${colorsPalettes.carbon[100]};
  margin: 12px 0 8px 0;
`;

export const StyledSkeleton = styled(Skeleton)`
  flex-shrink: 0;
`;

export const StyledSkeletonGroup = styled.div`
  margin-left: auto;
  width: 100%;
  display: flex;
  flex-direction: column;
  row-gap: 6px;

  & + & {
    margin-top: 20px;
  }
`;

export const StyledGraphSkeleton = styled(Skeleton)`
  margin: 16px 0;
`;
